/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.21.0
 * @since 1.21.0
 */

import { TTableColumnCell } from '../../../types';
import TableCell from '../TableCell';
import StatusBlockCell from './StatusBlockCell';
import { TTableCellStatusBlock } from './types';

function TableCellStatusBlock<D extends object>(cell: TTableCellStatusBlock<D>): Pick<TTableColumnCell<D>, 'Cell'> {
    return {
        Cell: props => TableCell(props)({
            render: ({ row }) => <StatusBlockCell {...cell(row)} />,
        }),
    };
}

export default TableCellStatusBlock;
